import {Partenaire} from '../models/partenaire.model';
import {ApiService} from './';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, of} from 'rxjs';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class PartenaireService {

  private _list: any[] = [{'id': 1, 'name': 'nom1', 'email': 'email1', 'description': 'desc1', 'is_active': true}
    , {'id': 2, 'name': 'nom2', 'email': 'email2', 'description': 'desc2', 'is_active': true}
    , {'id': 3, 'name': 'nom3', 'email': 'email3', 'description': 'desc3', 'is_active': true}
    , {'id': 4, 'name': 'nom4', 'email': 'email4', 'description': 'desc4', 'is_active': true}
    , {'id': 5, 'name': 'nom5', 'email': 'email5', 'description': 'desc5', 'is_active': true}
    , {'id': 6, 'name': 'nom6', 'email': 'email6', 'description': 'desc6', 'is_active': true}
    , {'id': 7, 'name': 'nom7', 'email': 'email7', 'description': 'desc7', 'is_active': true}
    , {'id': 8, 'name': 'nom8', 'email': 'email8', 'description': 'desc8', 'is_active': true}
    , {'id': 9, 'name': 'nom9', 'email': 'email9', 'description': 'desc9', 'is_active': true}
    , {'id': 10, 'name': 'nom10', 'email': 'email10', 'description': 'desc10', 'is_active': true}
    , {'id': 11, 'name': 'nom11', 'email': 'email11', 'description': 'desc11', 'is_active': true}
    , {'id': 12, 'name': 'nom12', 'email': 'email12', 'description': 'desc12', 'is_active': true}
    , {'id': 13, 'name': 'nom13', 'email': 'email13', 'description': 'desc13', 'is_active': true}
  ];

  private _observableList: BehaviorSubject<Partenaire[]> = new BehaviorSubject([]);

  constructor(private apiService: ApiService,
    private http: HttpClient) {}

  findById(id: number): Observable<Partenaire> {
    // return this.apiService.get('/gandadmin/associations/' + id);
    // return this._observableList.next();
    return of(this._list.filter(part => part.id === id)[0]);
  }

  add(partenaire: Partenaire): Observable<Partenaire> {
    const lastAssoc = this._list[this._list.length - 1];
    partenaire.id = lastAssoc.id + 1;
    partenaire.is_active = false;
    this._list.push(partenaire);
    this._observableList.next(this._list);
    return of(partenaire);
  }

  list(): Observable<Partenaire[]> {
    return Observable.of (this._list);
  }

  edit(user: Partenaire): Observable<Partenaire> {
    const item = this._list.filter(part => part.id === user.id)[0];
    item.name = user.name;
    item.email = user.email;
    item.description = user.description;
    return of(item);
  }

  banUser(user: Partenaire): Observable<Partenaire> {
    // const verb = user.is_active ? 'deactivate' : 'activate';
    // this.apiService.post('/gandadmin/associations/' + user.id + '/' + verb);
    const item = this._list.filter(part => part.id === user.id)[0];
    item.is_active = !item.is_active;
    return of(item);
  }
}
